import { analytics } from 'src/services';
import { useAuth } from '@frontegg/react';

const ZoomGuidedTour = () => {
  const { user } = useAuth();

  const handleClick = () => {
    analytics.track('Clicked Zoom Guided Tour', {
      email: user?.email,
    });
    window.open(
      'https://help.insighthealth.ai/en/articles/11939209-zoom-integration-guide',
      '_blank'
    );
  };

  return (
    <div className="flex flex-col">
      <p
        className="cursor-pointer gap-2 text-[#5a8dda] hover:underline"
        onClick={handleClick}
      >
        Zoom Integration Guide
      </p>
    </div>
  );
};

export default ZoomGuidedTour;
